import { Drawer, styled } from '@mui/material';

export const DRAWER_WIDTH = 240;
export const COLLAPSED_DRAWER_WIDTH = 70;

export const DesktopDrawer = styled(Drawer)(({ theme: { zIndex, visualRefresh }, open }) => ({
  width: 'inherit',
  flexShrink: 0,
  // The refresh draws every MUI surface with a 1px rim. This panel is flush with the screen on three
  // sides, so only its right edge, the one that meets the page, keeps one: a rim on the left sat
  // against the window edge, and on top it doubled the top bar's own bottom border.
  '& .MuiDrawer-paper': { width: 'inherit', ...(visualRefresh && { borderWidth: '0 1px 0 0' }) },
  zIndex: open ? zIndex.appBar - 1 : undefined,
}));
